import React from 'react'
import PropTypes from 'prop-types'
import CheckboxDropdownFilter from './CheckboxDropdownFilter'

const SchoolGradeFilter = ({ grades, onToggleGrade, selectedGradeNames }) => (
  <CheckboxDropdownFilter
    buttonLabel="Grade"
    dataTestId="school-summary-grade-filter"
    idPrefix="grade-filter"
    onToggle={onToggleGrade}
    options={grades}
    selectedKeys={selectedGradeNames}
  />
)

SchoolGradeFilter.propTypes = {
  grades: PropTypes.arrayOf(PropTypes.string).isRequired,
  onToggleGrade: PropTypes.func.isRequired,
  selectedGradeNames: PropTypes.oneOfType([
    PropTypes.instanceOf(Set),
    PropTypes.arrayOf(PropTypes.string),
  ]),
}

export default SchoolGradeFilter
